<app-footer>
  <button
    class="pay-btn"
    (click)="onPay()"
    [disabled]="!isPayButtonEnabled"
    [class.disabled]="!isPayButtonEnabled">

    @if (getPaymentMethodIcon(); as icon) {
      <img
        [src]="icon"
        [alt]="currentPaymentMethod"
        class="payment-btn-icon">
    }

    <span style="display: flex; align-items: center; gap: 4px">
      <span>{{ 'web.purchasePaymentButton' | translate }}</span>
      <span [textContent]="currentPaymentMethod | translate"></span>
      <span [textContent]="formService.getTotalAmount() | price: locale"></span>
    </span>

    <i class="fa-solid fa-arrow-right arrow-icon"></i>
  </button>

  <button
    #changePaymentBtn
    class="change-payment"
    (click)="onChangePayment()">
    {{ 'web.purchaseOtherPaymentOptionsButton' | translate }}
  </button>
</app-footer>

<app-payment-selection-modal
  [isOpen]="isPaymentModalOpen"
  (close)="onPaymentModalClosed()"
  [currentMethod]="currentMethod"
  (paymentMethodChanged)="onPaymentMethodChanged($event)">
</app-payment-selection-modal>
